import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { NotificationProvider } from './components/shared/NotificationSystem';
import { ConfirmProvider } from './components/shared/ConfirmContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import GymnasticsScoresApp from './App';
import HomeSelector from './views/HomeSelector';
import AdminLoginView from './components/auth/Login';
import JudgeLoginView from './views/JudgeLoginView';
import JudgeDashboard from './views/JudgeDashboard';
import JudgeScoreEntry from './views/JudgeScoreEntry';
import ClubLoginView from './views/ClubLoginView';
import ClubDashboard from './views/ClubDashboard';
import OrganizerLoginView from './views/OrganizerLoginView';
import OrganizerDashboard from './views/OrganizerDashboard';
import CoachLoginView from './views/CoachLoginView';
import CoachDashboard from './views/CoachDashboard';
import CoachQRAttendance from './views/CoachQRAttendance';
import ResetPasswordView from './views/ResetPasswordView';
// Componente router que envuelve la aplicación con las rutas
const AppRouter = () => {
  return (
    <NotificationProvider>
      <ConfirmProvider>
      <Router>
        <AuthProvider>
        <Routes>
          {/* Ruta principal - Selector de rol */}
          <Route path="/" element={<HomeSelector />} />
          
          {/* Ruta para resultados (público) */}
          <Route path="/resultados" element={<GymnasticsScoresApp initialRoute="resultados" />} />
          
          {/* Ruta para resultados de un evento específico por slug */}
          <Route path="/resultados/:slug" element={<GymnasticsScoresApp initialRoute="resultados" />} />
          
          {/* Ruta para jueces - Login (público) */}
          <Route path="/jueces" element={<JudgeLoginView />} />
          
          {/* Ruta para dashboard del juez (protegida) */}
          <Route path="/jueces/dashboard" element={
            <ProtectedRoute allowedRoles={['judge', 'admin']}>
              <JudgeDashboard />
            </ProtectedRoute>
          } />
          
          {/* Ruta para ingreso de puntajes del juez (protegida) */}
          <Route path="/jueces/scores/:eventId" element={
            <ProtectedRoute allowedRoles={['judge', 'admin']}>
              <JudgeScoreEntry />
            </ProtectedRoute>
          } />
          
          {/* Rutas para clubes */}
          <Route path="/clubes" element={<ClubLoginView />} />
          <Route path="/clubes/dashboard" element={
            <ProtectedRoute allowedRoles={['club', 'admin']}>
              <ClubDashboard />
            </ProtectedRoute>
          } />
          
          {/* Rutas para entrenadores */}
          <Route path="/entrenadores" element={<CoachLoginView />} />
          <Route path="/entrenadores/dashboard" element={
            <ProtectedRoute allowedRoles={['coach', 'admin']}>
              <CoachDashboard />
            </ProtectedRoute>
          } />
          
          {/* Rutas para organizadores */}
          <Route path="/organizador" element={<OrganizerLoginView />} />
          <Route path="/organizador/dashboard" element={
            <ProtectedRoute allowedRoles={['organizer', 'admin']}>
              <OrganizerDashboard />
            </ProtectedRoute>
          } />
          
          {/* Ruta pública de asistencia QR para entrenadores (QR general por club) */}
          <Route path="/asistencia/:clubId/:token" element={<CoachQRAttendance />} />
          
          {/* Ruta para login de administrador (pública) */}
          <Route path="/admin/login" element={<AdminLoginView onBackToHome={() => window.location.href = '/'} />} />
          
          {/* Ruta para administrador (protegida) */}
          <Route path="/admin" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <GymnasticsScoresApp initialRoute="admin" />
            </ProtectedRoute>
          } />
          
          {/* Ruta para reset de contraseña (pública, captura token de Supabase) */}
          <Route path="/reset-password" element={<ResetPasswordView />} />
          
          {/* Redirigir cualquier otra ruta a la página principal */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </AuthProvider>
      </Router>
      </ConfirmProvider>
    </NotificationProvider>
  );
};

export default AppRouter;
